



























































import Vue from "vue";

import IconButton from "../../../components/IconButton.vue";
import { ExtOrder, InvoiceRelationState, StoreIn, getRelationState } from "../models";
import store, { InvoiceItemStore } from "../services/store";
import flowStore, { InvoiceFlowStore } from "../../invoiceFlow/services/InvoiceFlowStore";
import Fragment from "../../../components/Fragment.vue";
import ExtOrderItemTable from "./ExtOrderItemTable.vue";
import RelationStateBadge from "./RelationStateBadge.vue";
import AddItemButton from "./AddItemButton.vue";
import OthersTable from "./OthersTable.vue";

interface Data {
  store: InvoiceItemStore;
  flowStore: InvoiceFlowStore;
}

interface Props {
  items: ExtOrder[];
}

interface Methods {
  getNetto(extOrder: ExtOrder): number;
  toggleDetails(extOrder: ExtOrder): void;
  getRelationState(item: StoreIn | ExtOrder): InvoiceRelationState;
  addExtOrder(item: ExtOrder): void;
}

export default Vue.extend<Data, Methods, {}, Props>({
  components: {
    IconButton,
    Fragment,
    ExtOrderItemTable,
    RelationStateBadge,
    AddItemButton,
    OthersTable,
  },

  data: () => ({
    store,
    flowStore,
  }),

  props: {
    items: {
      type: Array as () => ExtOrder[],
    },
  },

  computed: {
    hasData() {
      return this.items && this.items.length > 0;
    },

    currency() {
      return this.store.currency;
    },

    visibleItems() {
      return this.items.filter(
        (o) => this.store.selectedStateOption === getRelationState(o) && o.currency === this.store.currency
      );
    },
  },

  methods: {
    async addExtOrder(item: ExtOrder) {
      this.store.addExtOrder(item);
      if (this.flowStore.invoice.paymode == this.flowStore.paymentModes.find((x) => x.name == "Akkreditív")?.id) {
        this.flowStore.invoice.letterOfCredit = item.letterOfCredit;
      }
      await this.store.searchTrumesServicesByExtOrder(item);
      await this.store.save();
    },

    getRelationState,

    getNetto(extOrder: ExtOrder) {
      let sum = 0;
      if (extOrder.others != null) {
        sum = extOrder.others.reduce((acc, i) => acc + i.quantity * i.unitPrice, 0.0);
      }
      return extOrder.orderItems.reduce((acc, i) => acc + i.quantity * i.unitPrice, sum);
    },

    toggleDetails(extOrder: ExtOrder) {
      extOrder.expanded = !extOrder.expanded;
    },
  },
});
